import { Variants, motion } from "framer-motion"
import { ReactNode, memo } from "react"

interface RowProps {
  title: string
  children: ReactNode
  new?: boolean
  newGroup?: boolean
  endGroup?: boolean
  tooltip?: string
  icon?: ReactNode
  variants?: Variants
}

export const Row: React.FC<RowProps> = memo((props: RowProps) => {
  return (
    <motion.div
      variants={props.variants}
      className={`hidden grid-cols-[1fr_200px_200px_200px] border-t border-zinc-700 py-4 lg:grid xl:grid-cols-[1fr_260px_260px_260px] ${
        props.newGroup ? "mt-6" : ""
      } ${props.endGroup ? "border-b" : ""}`}
    >
      <div className="font-medium">
        <div className="flex items-center">
          {props.icon && (
            <div className="mr-3 text-amber-400">{props.icon}</div>
          )}
          <div>{props.title} </div>
          {props.new && (
            <span className="ml-2 mt-px rounded-lg bg-amber-900 px-1.5 py-0.5 text-xs text-amber-300">
              New
            </span>
          )}
        </div>
      </div>
      {props.children}
    </motion.div>
  )
})

Row.displayName = "Row"
